import React from "react";
import { useState } from "react";
import OverlayContainer from "../../../Overlay/OverlayContainer";
import { isNullOrEmpty } from "../../../../_helpers";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "../../../Other/element/Button";
import Image from "../../../Other/element/Image";

const Instructor = (props) => {
  const { t } = useTranslation();
  const [submit, setSubmit] = useState(false);

  const [formValues, setFormValues] = useState({
    studentEmail: props.user.email,
    courseID: "",
    courseName: "",
    teacherEmail: "",
    questions: [{ question: "" }],
  });
  const [errors, setErrors] = useState({
    questions: [],
  });

  const canAddMoreFields = (
    formData,
    errors,
    property,
    max,
    isNested = null
  ) => {
    let isValid = isNested
      ? formData[property].every((item) =>
          Object.values(item).every((value) => isNullOrEmpty(value))
        )
      : formData[property].every((item) => isNullOrEmpty(item));
    return (
      isValid &&
      formData[property].length < max &&
      errors[property].every((item) => item.valid)
    );
  };

  const addFormFields = (
    event,
    property,
    max,
    prevState,
    errors,
    value = "",
    accessor = null
  ) => {
    event.preventDefault();

    if (canAddMoreFields(prevState, errors, property, max, accessor)) {
      setFormValues({
        ...formValues,
        [property]: [...formValues[property], value],
      });
    }
  };

  const isDuplicate = (input, items) =>
    items.some(
      (item) => item.name.toLowerCase() === input.trim().toLowerCase()
    );

  const validateDuplicateText = (value, index, property, items) => {
    if (isNullOrEmpty(value) && isDuplicate(value, items)) {
      setErrors({
        ...errors,
        [property]:
          errors[property].filter((item) => item.id === index).length > 0
            ? errors[property]
            : [...errors[property], { id: index, vaild: false }],
      });
    } else {
      setErrors({
        ...errors,
        [property]: [...errors[property].filter((item) => item.id !== index)],
      });
    }
  };

  const removeFormFields = (event, index, property) => {
    event.preventDefault();
    let newFormValues = [...formValues[property]];
    newFormValues.splice(index, 1);
    setFormValues({ ...formValues, [property]: newFormValues });
  };

  const handleInputChange = (index, name, value, accessor = null) => {
    let clonedValues = [...formValues[name]];
    setFormValues({
      ...formValues,
      [name]: bindFormValues(index, value, clonedValues, accessor),
    });
  };
  const bindFormValues = (index, value, items, accessor = null) => {
    accessor ? (items[index][accessor] = value) : (items[index] = value);
    return items;
  };

  return (
    <>
      <OverlayContainer>
        {submit && (
          <div className="alert-dialog-inner">
            <div className="close-wrapper align-icon">
              <div
                className="alert-dialog-close"
                onClick={props.instructorQuery}
              >
                <i className="icon check"></i>
              </div>
            </div>

            <div>
              <div className="alert-title">
                <div className="icon-wrapper">
                  <Image
                    url="https://cdn.edusity.com/icons/icon-complete-check.svg"
                    alt="check-complete"
                  />
                </div>
                <div className="status-message">
                  <div className="status-title">
                    {t(
                      "Your submission is received and we will contact you soon."
                    )}
                  </div>
                  <p>{t("thankYou")}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {submit === false && (
          <div className="alert-dialog-inner">
            <div className="close-wrapper" onClick={props.instructorQuery}>
              <i className="icon check"></i>
            </div>

            <h1> Questions for the Instructor</h1>

            <div className="define-add-input">
              {formValues &&
                formValues?.questions?.map((item, index) => (
                  <div className="form-inline" key={index}>
                    <input
                      type="text"
                      className={
                        errors.questions.filter((item) => item.id === index)
                          .length > 0
                          ? "error"
                          : ""
                      }
                      name="questions"
                      placeholder={`Enter Question${index + 1}`}
                      value={item.question}
                      maxLength={120}
                      onChange={({ target }) =>
                        handleInputChange(
                          index,
                          target.name,
                          target.value,
                          "question"
                        )
                      }
                      onBlur={({ target }) =>
                        validateDuplicateText(
                          target.value,
                          index,
                          target.name,
                          [
                            ...formValues.questions.filter(
                              (_, i) => i !== index
                            ),
                          ]
                        )
                      }
                    />
                    <span>
                      Character remaining {120 - item?.question?.length}{" "}
                    </span>

                    {index > 0 && (
                      <img
                        href="javascript(void);"
                        name="questions"
                        className="align-textRemove"
                        onClick={(event) =>
                          removeFormFields(event, index, event.target.name)
                        }
                        src="https://cdn.edusity.com/icons/icon-trash.svg"
                        alt=""
                      />
                    )}
                  </div>
                ))}
            </div>

            <div className="define-add-text">
              <a
                href="javascript(void);"
                name="questions"
                onClick={(event) =>
                  addFormFields(
                    event,
                    event.target.name,
                    5,
                    formValues,
                    errors,
                    { question: "" },
                    true
                  )
                }
              >
                + Add More fields
              </a>
            </div>

            <div className="alert-close-btn">
              <Button
                className="btn"
                handleClick={() => setSubmit(true)}
                title=" Submit"
              />
            </div>
          </div>
        )}
      </OverlayContainer>
    </>
  );
};

function mapStateToProps(state) {
  const { user } = state.users;
  return {
    user,
  };
}

const connectedInstructor = connect(mapStateToProps)(Instructor);
export default connectedInstructor;
